<template>
  <div class="row slim-grid-row mb-3 pb-2">
    <div class="col-8">
      <p class="mb-0 body-2-2 font-bold">{{data.name}}</p>
      <p class="mb-0 body-2 font-regular">{{formatCurrency(data.price)}}</p>
    </div>
    <div class="col-4 text-right">
      <div v-if="qtyCart > 0" class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters mt-1 r-2px">
          <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus')">
            <svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="fill-primary" d="M11.8334 2.57332C11.8334 2.84947 11.6096 3.07332 11.3334 3.07332H0.666748C0.390606 3.07332 0.166748 2.84947 0.166748 2.57332V1.23999C0.166748 0.963848 0.390606 0.73999 0.666748 0.73999H11.3334C11.6096 0.73999 11.8334 0.963848 11.8334 1.23999V2.57332Z" fill="#26B11D"/>
            </svg>
            <!-- <img src="../../../../assets/img/icon/minus-orange.png" width="14"> -->
          </div>
          <div class="col-4 text-center">
            <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{qtyCart}}</p>
          </div>
          <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus')">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="fill-primary" d="M14 8.40662C14 8.68276 13.7761 8.90662 13.5 8.90662H8.5C8.22386 8.90662 8 9.13047 8 9.40662V14.4066C8 14.6828 7.77614 14.9066 7.5 14.9066H6.5C6.22386 14.9066 6 14.6828 6 14.4066V9.40662C6 9.13047 5.77614 8.90662 5.5 8.90662H0.5C0.223857 8.90662 0 8.68276 0 8.40662V7.40662C0 7.13047 0.223858 6.90662 0.5 6.90662H5.5C5.77614 6.90662 6 6.68276 6 6.40662V1.40662C6 1.13047 6.22386 0.906616 6.5 0.906616H7.5C7.77614 0.906616 8 1.13047 8 1.40662V6.40662C8 6.68276 8.22386 6.90662 8.5 6.90662H13.5C13.7761 6.90662 14 7.13047 14 7.40662V8.40662Z" fill="#26B11D"/>
            </svg>
            <!-- <img src="../../../../assets/img/icon/plus-orange.png" width="14"> -->
          </div>
        </div>
      <button v-else type="button" class="button-secondary text-12 align-top py-1 px-3" @click="changeQtyProduct('plus')">{{$t('hotel.action.add')}}</button>
    </div>

    <warning-box 
      v-if="show_popup_diff_serv"  
      @yes="addNewDifferentService"
      @no="close"
      :title="$t('hotel.concierge.fitur.laundry.different-laundry-service')"
      :body="$t('hotel.concierge.fitur.laundry.change-product')"
      :btn_primary="$t('hotel.concierge.fitur.laundry.yes')"
      :btn_secondary="$t('general.cancel')">  
    </warning-box>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {formatCurrency} from '@/utils/index.js'
  import WarningBox from '@/components/general/WarningBox'
  export default{
    props:['data','service'],
    components:{
      WarningBox
    },
    data(){
      return{
        show_popup_diff_serv: false
      }
    },
    computed:{
      qtyCart(){
        let data = 0
        let record_service = this.getConciergeOrder().custom.findIndex(x=>x.service.id==this.service.id)
        if(record_service != -1){
          let record_product = this.getConciergeOrder().custom[record_service].product.findIndex(y=>y.data.id==this.data.id)
          if(record_product != -1){
            data = this.getConciergeOrder().custom[record_service].product[record_product].qty
          }
        }
        return data
      }
    },
    methods:{
      ...mapGetters(['getMerchant','getConciergeOrder']),
      ...mapMutations(['setConciergeOrderCustomLaundry','resetConciergeOrder','setConciergeOrderCustomModule']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      changeQtyProduct(type){
        if(this.getConciergeOrder().custom.length == 0 || this.getConciergeOrder().custom[0].type == 'pcs'){
          let params = {
            type: 'pcs',
            service: this.service,
            product: this.data,
            qty: type == 'plus' ? this.qtyCart+1:this.qtyCart-1,
            notes: ''
          }
          if(type == 'plus' || (type == 'minus' && this.qtyCart > 0)){
            this.setConciergeOrderCustomLaundry(params)
            this.setConciergeOrderCustomModule('laundry')
          }else{
            console.log("UNKNOW FUNCTION")
          }
        }else{
          this.show_popup_diff_serv = true
        }
      },
      close(){
        this.show_popup_diff_serv = false
      },
      addNewDifferentService(){
        this.resetConciergeOrder()
        this.changeQtyProduct('plus')
        this.close()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuProductLaundry.vue